module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "text-align": "left"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.currentScene),
      expression: "currentScene"
    }],
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.currentScene = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, _vm._l((_vm.sceneList), function(item, index) {
    return _c('option', {
      key: index,
      domProps: {
        "value": item.id
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('hr'), _vm._v(" "), _c('div', {
    staticClass: "row my-5",
    staticStyle: {
      "margin": "0"
    }
  }, [_c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "scrollbar",
    attrs: {
      "id": "style-3"
    }
  }, [_c('div', {
    staticClass: "force-overflow"
  }, _vm._l((_vm.unusedData), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "p-0 m-0"
    }, [_c('li', [_c('span', {
      class: {
        'active': _vm.selectedData.some(function (el) {
          return el === item
        })
      },
      on: {
        "click": function($event) {
          return _vm.userSelected(item)
        }
      }
    }, [_vm._v(_vm._s(item))])])])
  }), 0)])]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.$t('select them_to_column')))])]), _vm._v(" "), _c('div', {
    staticClass: "col-2 m-auto"
  }, [_c('button', {
    staticClass: "btn btn-primary change-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.addUsedData
    }
  }, [_vm._v("> >")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary change-btn",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.removeUsedData
    }
  }, [_vm._v("< <")])]), _vm._v(" "), _c('div', {
    staticClass: "col-5"
  }, [_c('div', {
    staticClass: "wrapper"
  }, [_c('div', {
    staticClass: "scrollbar",
    attrs: {
      "id": "style-3"
    }
  }, [_c('div', {
    staticClass: "force-overflow"
  }, _vm._l((_vm.usedData), function(item, index) {
    return _c('ul', {
      key: index,
      staticClass: "p-0 m-0"
    }, [_c('li', [_c('span', {
      class: {
        'active': _vm.selectedData.some(function (el) {
          return el === item
        })
      },
      on: {
        "click": function($event) {
          return _vm.userSelected(item)
        }
      }
    }, [_vm._v(_vm._s(index + 1) + ". " + _vm._s(item))])])])
  }), 0)])])])]), _vm._v(" "), _c('div', {
    staticClass: "d-flex",
    staticStyle: {
      "float": "right"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary mx-3 px-",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.clearForm
    }
  }, [_vm._v(_vm._s(_vm.$t('cancel')))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-primary mx-3 px-4",
    attrs: {
      "disabled": _vm.usedLength < 7,
      "type": "button"
    },
    on: {
      "click": _vm.addVocabularies
    }
  }, [_vm._v(_vm._s(_vm.$t('save')))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-95ec2cb0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/cloud/vr/VocabularyForm.vue
// module id = 804
// module chunks = 3